import styled from "styled-components";

export const BlockText = styled.span`
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 21px;
`;
